import {
  createStyles,
  makeStyles,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Tooltip,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { ErrorStatus, SuccessStatus } from '../../../../icons/StatusIcons';
import { toolTipContent } from '../../ToolTipsInformation/ToolTipContent';
import { InfoIcon } from '../../../../icons/InfoIcon';

const useStyles = makeStyles((theme) =>
  createStyles({
    modal: {
      width: '400px',
      '@media screen and (max-width: 760px)': {
        width: '70vw',
      },
    },
    content: {
      padding: '3em',
      '@media screen and (max-width: 760px)': {
        padding: '0px',
      },
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
    iconContainer: {
      display: 'flex',
      alignItems: 'stretch',
      '& svg': {
        marginRight: '0.3em',
      },
    },
    typography: {
      '@media screen and (max-width: 760px) and (min-width: 301px)': {
        width: '235px',
      },
      '@media screen and (max-width: 300px)': {
        width: '150px',
      },
    },
  })
);

interface ConnectionModalProps {
  isModalOpen: boolean;
  setIsModalOpen: (isModalOpen: boolean) => void;
  sipConnectivityUSStatus: boolean;
  sipConnectivitySAStatus: boolean;
}

export function ConnectionModal({
  isModalOpen,
  setIsModalOpen,
  sipConnectivityUSStatus,
  sipConnectivitySAStatus,
}: ConnectionModalProps) {
  const classes = useStyles();

  return (
    <>
      <Dialog open={isModalOpen} onClose={() => setIsModalOpen(false)} classes={{ paper: classes.modal }}>
        <DialogTitle disableTypography>
          <Typography variant="h3" className={classes.typography}>
            Detailed connection information
          </Typography>
          <IconButton aria-label="close" className={classes.closeButton} onClick={() => setIsModalOpen(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers className={classes.content}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  <Typography variant="body1">
                    <strong>Status</strong>
                  </Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>
                  <div className={classes.iconContainer}>
                    <Tooltip title={toolTipContent.sipConnectivity} interactive leaveDelay={250}>
                      <div>
                        <InfoIcon />
                      </div>
                    </Tooltip>
                    {sipConnectivityUSStatus ? <SuccessStatus /> : <ErrorStatus />}
                    <Typography variant="body1">
                      <strong>SIP US Connectivity</strong>
                    </Typography>
                  </div>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  <div className={classes.iconContainer}>
                    <Tooltip title={toolTipContent.sipConnectivity} interactive leaveDelay={250}>
                      <div>
                        <InfoIcon />
                      </div>
                    </Tooltip>
                    {sipConnectivitySAStatus ? <SuccessStatus /> : <ErrorStatus />}
                    <Typography variant="body1">
                      <strong>SIP SA Connectivity</strong>
                    </Typography>
                  </div>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </DialogContent>
      </Dialog>
    </>
  );
}
